export default __webpack_public_path__ + "static/media/mccree-ult.b02795d4.mp3";